import moment from "moment";
import React, { useEffect, useMemo } from "react";
import { ITimelineColumnProps } from "./TimelineColumn";
import { SmallBody } from "src/components/Text";
import { monthLangTags } from "../utils";
import localize from "src/l10n/localize";

const TimelineColumnQuarter = (props: ITimelineColumnProps) => {
    const headerRef = React.useRef<HTMLDivElement>(null);

    const data = useMemo(() => {
        const from = moment(props.item.startMilliseconds);
        const to = moment(props.item.endMilliseconds);

        return {
            displayString: localize(monthLangTags[from.month()]).substring(0, 3) + " - " + localize(monthLangTags[to.month()]).substring(0, 3),
            isDecember: to.month() === 11,
            year: from.format("YYYY"),
            isJuly: from.month() === 6,
            isActive: from.isSame(moment(), 'quarter')
        }
    }, [props.item.startMilliseconds, props.item.endMilliseconds]);

    useEffect(() => {
        props.reportHeaderHeight(headerRef.current.clientHeight);
    }, [headerRef]);

    return (
        <div className="TimelineColumn" style={{
            width: props.columnWidth
        }}>
            <div ref={headerRef}>
                <div
                    className={[
                        "header-column",
                        data.isDecember ? "border-right" : "",
                    ].filter(x => !!x).join(" ")}
                    style={{
                        height: 32,
                        width: props.columnWidth,
                    }}>
                    <SmallBody>{data.isJuly && data.year}</SmallBody>
                </div>
                <div
                    className={[
                        "header-column",
                        "border-right",
                        (data.isActive ? " active" : "")
                    ].join(" ")}
                    style={{
                        width: props.columnWidth,
                        height: 36,
                    }}>
                    <div>
                        <SmallBody>{data.displayString}</SmallBody>
                    </div>
                </div>
            </div>
            <div className="border-right lane" style={{
                width: props.columnWidth,
                position: "relative"
            }}></div>
        </div>
    )
}

export default TimelineColumnQuarter;
